import { observer } from 'mobx-react-lite'
import { DeleteTaxRefundMethodDialog } from '@/features/tax-profile/tax-refund-methods/components/DeleteTaxRefundMethodDialog'
import { type DeleteTaxRefundMethodDialogViewModel } from '@/features/tax-profile/tax-refund-methods/components/DeleteTaxRefundMethodDialog/DeleteTaxRefundMethodDialogViewModel'
import { formatRefundMethodDescription } from '@/features/tax-profile/tax-refund-methods/TaxRefundMethod'

export interface DeleteTaxRefundMethodDialogContainerProps {
  vm: DeleteTaxRefundMethodDialogViewModel
}

/**
 * Container component for the delete tax refund method dialog.
 */
export const DeleteTaxRefundMethodDialogContainer = observer(
  ({ vm }: DeleteTaxRefundMethodDialogContainerProps) => {
    const displayName = vm.taxRefundMethod
      ? formatRefundMethodDescription(vm.taxRefundMethod)
      : ''

    return (
      <DeleteTaxRefundMethodDialog
        isOpen={vm.modal.showing}
        onClose={vm.cancel}
        displayName={displayName}
        isDeletePending={vm.delete.pending}
        onConfirmDeletePress={vm.delete}
      />
    )
  },
)
